/**
 * A short two-note chime, synthesised at runtime.
 *
 * Generated with the Web Audio API rather than shipped as an audio file, so
 * the widget stays a single self-contained bundle with no extra requests.
 *
 * Browsers block audio until the user has interacted with the page. The very
 * first proactive message may therefore be silent — that message also shows a
 * visual teaser, so nothing is missed — while every message after the visitor
 * has clicked will play.
 */

let context: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;

  const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;

  if (!context) {
    try {
      context = new Ctor();
    } catch {
      return null;
    }
  }

  return context;
}

function tone(ctx: AudioContext, frequency: number, startAt: number, duration: number): void {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();

  oscillator.type = 'sine';
  oscillator.frequency.value = frequency;

  // A quick fade in and out so the note doesn't click at its edges.
  gain.gain.setValueAtTime(0, startAt);
  gain.gain.linearRampToValueAtTime(0.14, startAt + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);

  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(startAt);
  oscillator.stop(startAt + duration);
}

/** Plays the incoming-message chime, silently doing nothing if audio is blocked. */
export function playIncomingChime(): void {
  const ctx = getContext();
  if (!ctx) return;

  // Autoplay policy can leave the context suspended until a gesture resumes it.
  if (ctx.state === 'suspended') {
    void ctx.resume().catch(() => undefined);
  }

  try {
    const now = ctx.currentTime;
    tone(ctx, 587.33, now, 0.12); // D5
    tone(ctx, 880.0, now + 0.09, 0.16); // A5
  } catch {
    // A blocked or closed context is not worth surfacing.
  }
}
